import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { fetchQAWorkOrder } from '../../actions/qa-work-orders'
import { loadQAServicingsForQAWorkOrder } from '../../actions/qa-servicings'

import QAWorkOrderDetails from '../../components/qa-work-orders/qa-work-order-details'

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.qaWorkOrderId

  const qaWorkOrder = state.qaWorkOrders[id]

  if (!qaWorkOrder) return { loading: true }

  const pagination = get(state, `pagination.qaServicingsByQAWorkOrder.${id}`, {})

  const location = state.locations[qaWorkOrder.location]
  const accountManagers = at(state.users, location.accountManagers || [])
  const qaServicings = at(state.qaServicings, pagination.ids || [])

  return {
    qaWorkOrder,
    qaServicings,
    locationModel: location,
    hasNextPage: pagination.nextPageUrl,
    accountManagers
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.qaWorkOrderId

  dispatch(fetchQAWorkOrder(id))
    .then(() => dispatch(loadQAServicingsForQAWorkOrder(id)))

  return {
    onLoadNextPage () {
      dispatch(loadQAServicingsForQAWorkOrder(id, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QAWorkOrderDetails)



// WEBPACK FOOTER //
// ./src/containers/qa-work-orders/qa-work-order-details-container.js